<template>
  <div @click="material_click_handling" class='col-xs-4 materials clickable' style='text-align: center;' :file_id="file.id" data-toggle='tooltip' data-placement='top' title='' :url="file.url" :name="file.name" action='download' data-original-title='Simple past'>
    <img data-type='icon' src='http://cuhk.fabulearn.net/assets/images/icon_file.png' style='height:36px' onerror='material_onerror(this)'>
    <div data-type='name'>{{file.name}}{{ext}}</div>
    <div v-show="false" data-type='description'>{{file.description}}</div>
  </div>
</template>
<script>
import $ from 'jquery'
export default {
  props: {
    file: Object
  //   id: Number,
  //   title: String,
  //   url: String,
  //   name: String,
  //   description: String
  // },
  // data () {
  //   return {
  //     id: 3,
  //     title: '',
  //     url: 'http://cuhk.fabulearn.net/courses/1/weeks/5/files/',
  //     name: 'Video',
  //     description: 'Simple past'
  //   }
  },
  methods: {
    material_click_handling: function (e) {
      let material = $(e.target).closest('.materials')
      console.log(material)
      window.open($(material).attr('url'))
    }
  },
  computed: {
    ext: function () {
      return this.file.download_name.substring(this.file.download_name.lastIndexOf('.'))
    }
  }
}
</script>
